import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ISignUpPayload,
  ISignInPayload,
  IFullSignInPayload,
  ISsoSignInPayload,
  IPasswordNewPayload,
  IFullPasswordNewPayload,
  IUpdatePasswordPayload,
  IFullUpdatePasswordPayload,
  IVerifyOTPPayload,
} from './types'

const config: AxiosRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json'
}

export function signUp(payload: ISignUpPayload) {
  return axios.post('/users', convertToSnakeCase(payload), config)
}

export function signIn(payload: ISignInPayload) {
  const fullSignInPayload: IFullSignInPayload = {
    utf8: '✓',
    commit: 'Log in',
    user: payload,
  }

  return axios.post('/users/sign_in', convertToSnakeCase(fullSignInPayload), config)
}

export function ssoSignIn(payload: ISsoSignInPayload) {
  return axios.post('/api/v1/sso/auth', convertToSnakeCase(payload))
}

export function passwordNew(payload: IPasswordNewPayload) {
  const fullPasswordNewPayload: IFullPasswordNewPayload = {
    utf8: '✓',
    commit: 'Send me reset password instructions',
    user: payload,
  }

  return axios.post('/users/password', convertToSnakeCase(fullPasswordNewPayload), config)
}

export function updatePassword(payload: IUpdatePasswordPayload) {
  const fullUpdatePasswordPayload: IFullUpdatePasswordPayload = {
    utf8: '✓',
    commit: 'Update my password',
    user: payload,
  }

  return axios.put('/users/password', convertToSnakeCase(fullUpdatePasswordPayload), config)
}

export function createOTP() {
  return axios.post('/api/v1/users/otp_confirmation', null, config)
}

export function verifyOTP(payload: IVerifyOTPPayload) {
  return axios.post('/api/v1/users/otp_confirmation/verify', convertToSnakeCase(payload), config)
}
